export default __webpack_public_path__ + "static/media/cookie.c0518ed1.svg";